import { useCallback, useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { APP_ROUTES } from '../constants'

export default function useCanGoBack() {
    const location = useLocation()
    const navigate = useNavigate()

    const canGoBack = useMemo(() => {
        if (typeof window === 'undefined') return false
        try {
            const pathDepth = location.pathname.split('/').filter(Boolean).length

            const histState = (window.history.state as any) || {}
            const hasHistoryIndex = typeof histState.idx === 'number' && histState.idx > 0
            const hasSameOriginReferrer =
                typeof document !== 'undefined' &&
                !!document.referrer &&
                document.referrer.startsWith(window.location.origin)

            return (hasHistoryIndex || hasSameOriginReferrer) && pathDepth >= 2
        } catch {
            return false
        }
    }, [location])

    const goBackSafely = useCallback(() => {
        if (canGoBack) navigate(-1)
        else navigate(APP_ROUTES.DASHBOARD)
    }, [canGoBack, navigate])

    return { canGoBack, goBackSafely }
}
